<app-generic-combobox
  [txtLabel]="txtLabel"
  [options]="options"
  [selected]="selected"
  (optionSelected)="getSelectedYear($event)"
>
</app-generic-combobox>
